import { api } from '@/lib/api-client'
import { isHiddenEntity } from '@/shared/constants/demo-data'

// Minimal entity shape for cross-system selectors. Lives in `shared/api`
// because both user-management (Departments tab) and entities itself need
// the entity list, and the ESLint boundaries prevent user-management from
// reaching into `@/systems/entities` directly.
export interface EntityOption {
  id: string
  name: string
  is_active: boolean
}

interface ApiEntityRow {
  id: string
  name: string
  status?: string
  is_active?: boolean
}

interface ApiEntitiesResponse {
  entities: ApiEntityRow[]
  total_count?: number
}

export async function getEntitiesList(): Promise<EntityOption[]> {
  const data = await api.get<ApiEntitiesResponse | ApiEntityRow[]>('/entities')
  const rows = Array.isArray(data) ? data : (data.entities ?? [])
  return rows
    .filter((e) => !isHiddenEntity(e.id))
    .map((e) => ({
    id: e.id,
    name: e.name,
    is_active: e.is_active ?? e.status !== 'inactive',
  }))
}
